import { Box, TextField, Typography } from "@mui/material"
import { useEffect } from "react"
import { convertDateTime } from "utils/util"

const DataFechamento = (props: { date: string, onSetDataFechamento: (dataFechamento: string) => void }) => {
    useEffect(() => {
        props.onSetDataFechamento(new Date().toString())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box sx={{ width: '100%' }}>
            <Typography sx={{ fontSize: '16px' }}>Data e Hora de fechamento</Typography>
            <TextField fullWidth variant="standard" disabled value={convertDateTime(props.date)} id="data_fechamento" />
        </Box>
    )
}

export default DataFechamento